module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ulricehamn-d97a957538c3f03582887c26a0934321.png";